import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleAllItems } from '../../../../data/reducers/resolveViolationsReducer';
import ResolveViolationsCard from './ResolveViolationsCard';
import './ResolveViolationsCardsList.css';

/**
 * List component for displaying all violation cards.
 *
 * @param {Object} props Component props
 * @param {Array} props.items Array of items to display
 * @param {Array} props.selectedItems Array of selected item IDs
 */
const ResolveViolationsCardsList = ({ items, selectedItems }) => {
	const dispatch = useDispatch();

	// Only show open items
	const openItems = items.filter((item) => item.is_open);

	const allSelected =
		openItems.length > 0 &&
		openItems.every((item) => selectedItems.includes(item.queued_email_id));

	const handleSelectAll = () => {
		dispatch(toggleAllItems());
	};

	if (openItems.length === 0) {
		return (
			<div className="resolve-violations-cards-list">
				<div className="no-items-message">
					<p>No open items available for resolution.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="resolve-violations-cards-list">
			{/* Select All Control */}
			<div className="select-all-bar">
				<label className="select-all-label">
					<input
						type="checkbox"
						checked={allSelected}
						onChange={handleSelectAll}
					/>
					<span>Select All ({openItems.length} items)</span>
				</label>
				<div className="selected-count">
					<strong>{selectedItems.length}</strong> of {openItems.length} selected
				</div>
			</div>

			{/* Cards List */}
			<div className="cards-container">
				{openItems.map((item) => (
					<ResolveViolationsCard
						key={item.queued_email_id}
						item={item}
						isSelected={selectedItems.includes(item.queued_email_id)}
					/>
				))}
			</div>
		</div>
	);
};

export default ResolveViolationsCardsList;
